import { render, staticRenderFns } from "./SwiperWrap.vue?vue&type=template&id=1d22d4f4"
import script from "./SwiperWrap.vue?vue&type=script&lang=js"
export * from "./SwiperWrap.vue?vue&type=script&lang=js"
import style0 from "./SwiperWrap.vue?vue&type=style&index=0&id=1d22d4f4&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports